import { decryptToken } from "../utils/getToken";
import TasksPage from "../../shared/tasks/components/TasksPage";
import TaskModal from "./TaskModal";
import TaskModalEdit from "./TaskModalEdit";
import TaskHistory from "./TaskHistory";

const Task = () => (
    <TasksPage
        role="staff"
        apiUrl={process.env.REACT_APP_LINK}
        getToken={() => decryptToken("accessToken") || ""}
        TaskModal={TaskModal}
        TaskModalEdit={TaskModalEdit}
        TaskHistory={TaskHistory}
        EmptyStateBlock={null}
    />
);

export default Task;
